<span *ngIf="chatMessage?.from !== ChatMessageFromEnum.ME" class="author">{{ chatMessage?.senderName }}</span>
<span class="message">{{ chatMessage?.message }}</span>
<span class="date">
  {{
    (isToday(chatMessage?.transmissionTime) ? '' : chatMessage?.transmissionTime?.toLocaleDateString() + ' ') +
      chatMessage?.transmissionTime?.toLocaleTimeString()?.slice(0, -3) +
      ' Uhr'
  }}
</span>
